import { render, staticRenderFns } from "./smartProduct.vue?vue&type=template&id=731dfad2&scoped=true"
import script from "./smartProduct.vue?vue&type=script&lang=js"
export * from "./smartProduct.vue?vue&type=script&lang=js"
import style0 from "./smartProduct.vue?vue&type=style&index=0&id=731dfad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731dfad2",
  null
  
)

export default component.exports